module["exports"] = [
  "deposit",
  "withdrawal",
  "payment",
  "invoice"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/finance/transaction_type.js
// module id = 899
// module chunks = 1